export default "__VITE_ASSET__Ds8RohmL__"